import NotificationsScreen from '@screens/Notifications/NotificationsScreen';

export default NotificationsScreen;
